export type Styles = {
    type?: string
    offset?: string
    transition?: number
    delay?: number
}

export const getRevealerStyles = (styleProps: Styles, inView: boolean): Record<string, string | number> => {
    const { type = 'y', offset = '50px', transition = 800, delay = 0 } = styleProps

    return {
        transitionProperty: 'opacity transform',
        transitionDuration: `${transition}ms`,
        transitionDelay: `${delay}ms`,
        opacity: inView ? 1 : 0,
        transform: `translate${type}(${inView ? 0 : offset})`,
        overflow: 'visible',
        width: '100%',
    }
}
